module.exports = __webpack_public_path__ + "static/img/sr_tradingaccount.d87afca.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/sr_tradingaccount.png
// module id = 9cpV
// module chunks = 1